<div class="paging-container" *ngIf="resultsArray.length > 1">
  <a (click)="pagingEventClick(1)" [hidden]="!showFirstLink">
    <img src="/assets/img/left-angle-bracket.svg"/><img src="/assets/img/left-angle-bracket.svg"
  /></a>
  <a (click)="pagingEventClick(pagedResult.CurrentPageNumber - 1)"><img src="/assets/img/left-angle-bracket.svg"/></a>
  <a *ngFor="let pageNumber of resultsArray; let i = index" (click)="pagingEventClick(pageNumber)">
    <img *ngIf="pageNumber == pagedResult.CurrentPageNumber" src="/assets/img/bullet-full.svg" />
    <img *ngIf="pageNumber != pagedResult.CurrentPageNumber" src="/assets/img/bullet-empty.svg" />
  </a>
  <a (click)="pagingEventClick(pagedResult.CurrentPageNumber + 1)"><img src="/assets/img/right-angle-bracket.svg"/></a>
  <a (click)="pagingEventClick(pagedResult.TotalPages)" [hidden]="!showLastLink"
    ><img src="/assets/img/right-angle-bracket.svg"/><img src="/assets/img/right-angle-bracket.svg"
  /></a>
</div>
